var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgClose({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.15229 8L15.2372 1.89488C15.5606 1.57143 15.5606 1.06604 15.2372 0.742588C14.9137 0.419137 14.4084 0.419137 14.0849 0.742588L8 6.84771L1.89488 0.762803C1.57143 0.439353 1.06604 0.439353 0.742588 0.762803C0.419137 1.08625 0.419137 1.59164 0.742588 1.91509L6.84771 8L0.762803 14.1051C0.439353 14.4286 0.439353 14.934 0.762803 15.2574C1.08625 15.5809 1.59164 15.5809 1.91509 15.2574L8 9.15229L14.1051 15.2574C14.4286 15.5809 14.934 15.5809 15.2574 15.2574C15.5809 14.934 15.5809 14.4286 15.2574 14.1051L9.15229 8Z",
    fill: "#96A1AC"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgClose);
export default __webpack_public_path__ + "static/media/close.590a04f0f068936d83317689bd4092b6.svg";
export { ForwardRef as ReactComponent };